import { modelTerminology } from 'javascripts/terminology';
import { type RemoteAttributes } from '../RecordAction';
import { PageAction } from '../PageAction';
import type ApplicationModel from 'components/framework/ApplicationModel';
import { Page } from 'components/framework/models';

export class MovePageAction extends PageAction {
  documentTypes = Page.DOCUMENT_TYPES_EXCEPT_LINKS;

  isRemoteLink = true;

  get title() {
    const record = this.selectedRecords[0];
    const recordType = modelTerminology(record).toLowerCase();

    return `Move ${recordType}`;
  }

  get icon() {
    return 'fa-regular fa-file-export';
  }

  remoteLinkAttributes(records: Page[]): RemoteAttributes {
    const record = records[0];
    const { referenceNum, isPersonal } = record;
    const prefix = isPersonal ? 'user/pages' : 'pages';

    return {
      href: `/${prefix}/${referenceNum}/change_project`,
      method: 'get',
    };
  }

  showForRecord(record: ApplicationModel): record is Page {
    return (
      super.showForRecord(record) &&
      // Use the update action as a proxy for moving the page
      record.permissions?.update !== false &&
      this.selectedRecords.length === 1
    );
  }
}
